import { ChangePassword } from "@standard/pages/auth";

export default ChangePassword;
